import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import SearchSelect from "../components/searchAndSelect";
import {
  Box,
  Typography,
  Grid,
  FormControl,
  InputLabel,
  Input,
  Button,
  FormControlLabel,
  Checkbox,
  FormLabel,
  RadioGroup,
  Radio,
} from "@mui/material";
import {
  addOrg,
  getOrgsDetails,
  putUpdateOrg,
  addBankDetails,
  addAdBankDetails,
  getBankDetails,
  getAdBankDetails,
  putBankDetails,
  putAdBankDetails,
  getAdBankDetailsOutward,
  getBankDetailsOutward
} from "../services/httpCalls";
import useNotify from "../utils/useNotify";
import { useSetRecoilState, useRecoilValue } from "recoil";
import { useLocation } from "react-router-dom";
import { showloader, editactive } from "../store/gloabalState";
function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function CreateOrg({ orgIdNew, mode }) {
  const [getState, setState] = React.useState(0);
  const isEditActive = useRecoilValue(editactive)
  const [getBankFormDetails, setBankFormDetails] = useState({
    bankName: "",
    accountNumber: "",
    ifscCode: "",
    customerId: "",
    isPrimaryAccount: false,
  });

  const [getAdBankFormDetails, setAdBankFormDetails] = useState({
    bankName: "",
    bsrCode: "",
    ifscCode: "",
    customerId: "",
    isPrimaryAccount: false,
  });
  const [bankTypeId, setBankTypeId] = useState({
    adBankId: '',
    bankId: ""
  })
  const [bankIdOutward, setBankIdOutward] = useState('')
  const [adbankIdOutward, setADBankIdOutward] = useState('')
  const [createOrgForm, setCreateOrgForm] = useState({
    name: "",
    panNumber: "",
    gstState: "",
    gstNumber: "",
    leiNumber: "",
    charteredAccountantChoice: "own",
    address: {
      addressLineOne: "",
      addressLineTwo: "",
      city: "",
      state: "",
      pinCode: "",
      country: "",
    },
  });
  const [editFlag, setEditFlag] = useState(false);
  const [editTabs, setEditTabs] = useState(false);
  const [loadingButton, setLoadingButton] = useState(false);
  const [getSearchInput, setSearchInput] = useState(true);
  const [orgId, setOrgId] = useState(orgIdNew);
  const setShowLoader = useSetRecoilState(showloader);
  const noLei =
    "LEI number not available as the company has not registered yet";
  const [leiFlag, setLeiFlag] = useState(false);

  let notify = useNotify();

  const createOrgFun = async (e) => {
    if (editFlag) {
      e.preventDefault();
      setLoadingButton(true)
      let data = {
        name: createOrgForm.name,
        panNumber: createOrgForm.panNumber,
        gstNumber: createOrgForm.gstNumber,
        gstState: createOrgForm.gstState,
        leiNumber: createOrgForm.leiNumber,
        charteredAccountantChoice: createOrgForm.charteredAccountantChoice,
        address: {
          id: createOrgForm.address.id,
          addressLineOne: createOrgForm.address.addressLineOne,
          addressLineTwo: createOrgForm.address.addressLineTwo,
          city: createOrgForm.address.city,
          state: createOrgForm.address.state,
          country: createOrgForm.address.country,
          pinCode: createOrgForm.address.pinCode,
        },
      };
      if (leiFlag) {
        data.leiNumber = noLei;
      } else {
        data = {
          name: createOrgForm.name,
          panNumber: createOrgForm.panNumber,
          gstNumber: createOrgForm.gstNumber,
          gstState: createOrgForm.gstState,
          leiNumber: createOrgForm.leiNumber,
          charteredAccountantChoice: createOrgForm.charteredAccountantChoice,
          address: {
            id: createOrgForm.address.id,
            addressLineOne: createOrgForm.address.addressLineOne,
            addressLineTwo: createOrgForm.address.addressLineTwo,
            city: createOrgForm.address.city,
            state: createOrgForm.address.state,
            country: createOrgForm.address.country,
            pinCode: createOrgForm.address.pinCode,
          },
        };
      }

      putUpdateOrg(data, orgId)
        .then(() => {
          notify.success("Updated Organization!");
          setLoadingButton(false)
        })
        .catch(() => {
          notify.error("Not Able to Update Organization!");
          setLoadingButton(false)
        });
    } else {
      e.preventDefault();
      setShowLoader(true);
      let data = createOrgForm;
      if (leiFlag) {
        data.leiNumber = noLei;
      } else {
        data = createOrgForm;
      }
      addOrg(data)
        .then((res) => {
          setShowLoader(false);
          notify.success("Added Organization Successfully!");
          setCreateOrgForm({
            name: "",
            panNumber: "",
            gstState: "",
            gstNumber: "",
            leiNumber: "",
            charteredAccountantChoice: false,
            address: {
              addressLineOne: "",
              addressLineTwo: "",
              city: "",
              state: "",
              pinCode: "",
              country: "",
            },
          });
          setLoadingButton(false)
        })
        .catch(() => {
          setShowLoader(false);
          notify.error("Not Able to Add Organization!");
          setLoadingButton(false)
        });
    }
  };

  const OnTabSwitch = (event, newValue) => {
    setState(newValue);
  };

  const routerPath = useLocation();
  const pathname = routerPath.pathname;

  // useEffect(() => {
  //   const fetchData = async () => {
  //     let url_ = window.location.pathname;
  //     if (pathname === "/addorg") {
  //       setEditFlag(false);
  //       setEditTabs(false);
  //       setSearchInput(true);
  //       setCreateOrgForm({
  //         name: "",
  //         panNumber: "",
  //         gstState: "",
  //         gstNumber: "",
  //         leiNumber: "",
  //         charteredAccountantChoice: false,
  //         address: {
  //           addressLineOne: "",
  //           addressLineTwo: "",
  //           city: "",
  //           state: "",
  //           pinCode: "",
  //           country: "",
  //         },
  //       });
  //       setAdBankFormDetails({
  //         bankName: "",
  //         bsrCode: "",
  //         ifscCode: "",
  //         customerId: "",
  //         isPrimaryAccount: "",
  //       });
  //       setBankFormDetails({
  //         bankName: "",
  //         accountNumber: "",
  //         ifscCode: "",
  //         customerId: "",
  //         isPrimaryAccount: "",
  //       });
  //     } else {
  //       await preFetchData(url_);
  //     }
  //   };
  //   fetchData();
  // }, [pathname]);

  // const preFetchData = (url_) => {
  //   // let orgId_ = url_.trim();
  //   let orgId_ = localStorage.getItem("orgId")
  //   let getRouteName = url_.split("/")[1];
  //   orgId_ = url_.split("/")[2];
  //   let bankId_ = url_.split("/")[3];
  //   setOrgId(orgId_);
  //   if (orgId_ && getRouteName === "editorg") {
  //     setState(0);
  //     setEditTabs(true);
  //     setEditFlag(true);
  //     getOrgsDetails(orgId_).then((res) => {
  //       setCreateOrgForm({
  //         name: res.name,
  //         panNumber: res.panNumber,
  //         gstState: res.gstState,
  //         gstNumber: res.gstNumber,
  //         leiNumber: res.leiNumber,
  //         charteredAccountantChoice: res.charteredAccountantChoice,
  //         address: {
  //           addressLineOne: res.address.addressLineOne,
  //           addressLineTwo: res.address.addressLineTwo,
  //           city: res.address.city,
  //           state: res.address.state,
  //           pinCode: res.address.pinCode,
  //           country: res.address.country,
  //           id: res.address.id,
  //         },
  //       });
  //     });
  //   }
  //   if (getRouteName === "editBank") {
  //     setState(1);
  //     setEditTabs(true);
  //     setEditFlag(true);
  //     getBankDetails(bankId_)
  //       .then((res) => {
  //         setSearchInput(false);
  //         setBankFormDetails({
  //           accountNumber: res.accountNumber,
  //           customerId: res.customerId,
  //           bankName: res.bankName,
  //           ifscCode: res.ifscCode,
  //           isPrimaryAccount: res.isPrimaryAccount,
  //         });
  //       })
  //       .catch(() => {
  //         notify.error("Not able to fetch bank details!");
  //       });
  //   }
  //   if (getRouteName === "editAdBank") {
  //     setState(2);
  //     setEditTabs(true);
  //     setEditFlag(true);
  //     getAdBankDetails(bankId_)
  //       .then((res) => {
  //         setSearchInput(false);
  //         setAdBankFormDetails({
  //           bankName: res.bankName,
  //           bsrCode: res.bsrCode,
  //           ifscCode: res.ifscCode,
  //           customerId: res.customerId,
  //           isPrimaryAccount: res.isPrimaryAccount,
  //         });
  //       })
  //       .catch(() => {
  //         notify.error("Not able to fetch AD bank details!");
  //       });
  //   }
  // };
  const getADBankDetailsOutwardFill = async () => {
    let orgId = localStorage.getItem('orgId')
    getAdBankDetailsOutward(orgId).then((res) => {
      if (res?.length) {
        res?.forEach((bank) => {
          setAdBankFormDetails(
            {
              bankName: bank.bankName,
              bsrCode: bank.bsrCode,
              ifscCode: bank.ifscCode,
              customerId: bank.customerId,
              isPrimaryAccount: bank.isPrimaryAccount,
            }
          )

          setADBankIdOutward(bank.id)
        })
      }
    })
  }
  const getBankDetailsOutwardFill = async () => {
    let orgId = localStorage.getItem('orgId')
    getBankDetailsOutward(orgId).then((res) => {
      if (res?.length) {
        res?.forEach((bank) => {
          setBankFormDetails(
            {
              bankName: bank.bankName,
              bsrCode: bank.bsrCode,
              ifscCode: bank.ifscCode,
              customerId: bank.customerId,
              accountNumber: bank.accountNumber,
              isPrimaryAccount: bank.isPrimaryAccount,
            }
          )
          setBankIdOutward(bank.id)
        })
      }

    })
  }

  useEffect(() => {
    getADBankDetailsOutwardFill()
    getBankDetailsOutwardFill()
  }, [])
  const createBankDetailFun = (event) => {
    setLoadingButton(true)
    setShowLoader(true);
    event.preventDefault();

    let data = {
      bankName: getBankFormDetails.bankName,
      accountNumber: getBankFormDetails.accountNumber,
      ifscCode: getBankFormDetails.ifscCode,
      customerId: getBankFormDetails.customerId,
      isPrimaryAccount: getBankFormDetails.isPrimaryAccount === "true" ? true : false,
    };
    if (mode === "edit" && bankIdOutward !== '') {
      let orgId___ = localStorage.getItem("orgId")
      putBankDetails(orgId___, bankIdOutward, data)
        .then((res) => {
          setShowLoader(false);
          notify.success("Updated Bank Details Successfully!");
          setLoadingButton(false)
        })
        .catch(() => {
          setShowLoader(false);
          notify.error("Not able to update bank details!");
          setLoadingButton(false)
        });
    } else {
      let orgId___ = localStorage.getItem("orgId")
      addBankDetails(orgId___, data)
        .then(() => {
          setShowLoader(false);
          notify.success("Added Bank Details Successfully!");
          setLoadingButton(false)
        })
        .catch(() => {
          setShowLoader(false);
          notify.error("Not able to add bank details!");
          setLoadingButton(false)
        });
    }
  };

  const createAdBankDetailFun = (event) => {
    let url_ = window.location.pathname;

    setLoadingButton(true)
    setShowLoader(true);
    event.preventDefault();

    let data = {
      bankName: getAdBankFormDetails.bankName,
      bsrCode: getAdBankFormDetails.bsrCode,
      ifscCode: getAdBankFormDetails.ifscCode,
      customerId: getAdBankFormDetails.customerId,
      isPrimaryAccount: getAdBankFormDetails.isPrimaryAccount === "true" ? true : false,
    };

    if (mode === "edit" && adbankIdOutward !== '') {
      let orgId___ = localStorage.getItem("orgId")
      putAdBankDetails(orgId___, adbankIdOutward, data)
        .then(() => {
          setShowLoader(false);
          notify.success("Updated AD Bank Details Successfully!");
          setLoadingButton(false)
        })
        .catch(() => {
          setShowLoader(false);
          notify.error("Not able to add bank details!");
          setLoadingButton(false)
        });
    } else {
      let orgId___ = localStorage.getItem("orgId")
      let adBankData = {
        bankName: getAdBankFormDetails.bankName,
        accountNumber: getAdBankFormDetails.accountNumber,
        ifscCode: getAdBankFormDetails.ifscCode,
        customerId: getAdBankFormDetails.customerId,
        bsrCode: getAdBankFormDetails.bsrCode,
        isPrimaryAccount: getAdBankFormDetails.isPrimaryAccount === "true" ? true : false,
      }
      addAdBankDetails(orgId___, adBankData)
        .then(() => {
          setShowLoader(false);
          notify.success("Added AD Bank Details Successfully!");
          setLoadingButton(false)
        })
        .catch(() => {
          setShowLoader(false);
          notify.error("Not able to add bank details!");
          setLoadingButton(false)
        });
    }
  };

  const selectSearchData = (e) => {
    setOrgId(e.id);
    // if(orgIdNew){
    //   setOrgId(orgIdNew)
    // }
  };
  return (
    <Box sx={{ padding: "1rem" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs value={getState} onChange={OnTabSwitch}>
          {/* <Tab
            label="Create Organization"
            {...a11yProps(0)}
            disabled={editTabs}
          /> */}
          <Tab
            label="Create Bank Details"
            {...a11yProps(0)}
            disabled={editTabs}
          />
          <Tab
            label="Create AD Bank Details"
            {...a11yProps(1)}
            disabled={editTabs}
          />
        </Tabs>
      </Box>
      {/* <TabPanel value={getState} index={0}>
        <Typography
          variant="h5"
          sx={{ paddingBottom: "1rem", fontWeight: 400 }}
        >
          {editFlag ? "Edit Organization" : "Create Organization"}
        </Typography>
        <Box component="form" validate onSubmit={(e) => createOrgFun(e)}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <FormControl
                variant="standard"
                required
                sx={{ width: "300px", display: "block", marginTop: ".5rem" }}
              >
                <InputLabel htmlFor="name">Customer Name</InputLabel>
                <Input
                  id="name"
                  onChange={(e) =>
                    setCreateOrgForm({
                      ...createOrgForm,
                      [e.target.id]: e.target.value,
                    })
                  }
                  value={createOrgForm.name}
                  sx={{ width: "100%" }}
                />
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl
                variant="standard"
                required
                sx={{ width: "300px", display: "block", marginTop: ".5rem" }}
              >
                <InputLabel htmlFor="panNumber">PAN</InputLabel>
                <Input
                  id="panNumber"
                  onChange={(e) =>
                    setCreateOrgForm({
                      ...createOrgForm,
                      [e.target.id]: e.target.value,
                    })
                  }
                  value={createOrgForm.panNumber}
                  sx={{ width: "100%" }}
                />
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl
                variant="standard"
                required
                sx={{ width: "300px", display: "block", marginTop: ".5rem" }}
              >
                <InputLabel htmlFor="gstState">GST State</InputLabel>
                <Input
                  id="gstState"
                  onChange={(e) =>
                    setCreateOrgForm({
                      ...createOrgForm,
                      [e.target.id]: e.target.value,
                    })
                  }
                  value={createOrgForm.gstState}
                  sx={{ width: "100%" }}
                />
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl
                variant="standard"
                required
                sx={{ width: "300px", display: "block", marginTop: ".5rem" }}
              >
                <InputLabel htmlFor="gstNumber">GST Number</InputLabel>
                <Input
                  id="gstNumber"
                  onChange={(e) =>
                    setCreateOrgForm({
                      ...createOrgForm,
                      [e.target.id]: e.target.value,
                    })
                  }
                  value={createOrgForm.gstNumber}
                  sx={{ width: "100%" }}
                />
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl
                variant="standard"
                required
                sx={{ width: "300px", display: "block", marginTop: ".5rem" }}
              >
                <InputLabel htmlFor="addressLineOne">Address Line 1</InputLabel>
                <Input
                  id="addressLineOne"
                  onChange={(e) =>
                    setCreateOrgForm({
                      ...createOrgForm,
                      address: {
                        ...createOrgForm.address,
                        [e.target.id]: e.target.value,
                      },
                    })
                  }
                  value={createOrgForm.address.addressLineOne}
                  sx={{ width: "100%" }}
                />
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl
                variant="standard"
                required
                sx={{ width: "300px", display: "block", marginTop: ".5rem" }}
              >
                <InputLabel htmlFor="city">City</InputLabel>
                <Input
                  id="city"
                  onChange={(e) =>
                    setCreateOrgForm({
                      ...createOrgForm,
                      address: {
                        ...createOrgForm.address,
                        [e.target.id]: e.target.value,
                      },
                    })
                  }
                  value={createOrgForm.address.city}
                  sx={{ width: "100%" }}
                />
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl
                variant="standard"
                sx={{ width: "300px", display: "block", marginTop: ".5rem" }}
              >
                <InputLabel htmlFor="addressLineTwo">Address Line 2</InputLabel>
                <Input
                  id="addressLineTwo"
                  onChange={(e) =>
                    setCreateOrgForm({
                      ...createOrgForm,
                      address: {
                        ...createOrgForm.address,
                        [e.target.id]: e.target.value,
                      },
                    })
                  }
                  value={createOrgForm.address.addressLineTwo}
                  sx={{ width: "100%" }}
                />
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl
                variant="standard"
                required
                sx={{ width: "300px", display: "block", marginTop: ".5rem" }}
              >
                <InputLabel htmlFor="state">State</InputLabel>
                <Input
                  id="state"
                  onChange={(e) =>
                    setCreateOrgForm({
                      ...createOrgForm,
                      address: {
                        ...createOrgForm.address,
                        [e.target.id]: e.target.value,
                      },
                    })
                  }
                  value={createOrgForm.address.state}
                  sx={{ width: "100%" }}
                />
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl
                variant="standard"
                required
                sx={{ width: "300px", display: "block", marginTop: ".5rem" }}
              >
                <InputLabel htmlFor="country">Country</InputLabel>
                <Input
                  id="country"
                  onChange={(e) =>
                    setCreateOrgForm({
                      ...createOrgForm,
                      address: {
                        ...createOrgForm.address,
                        [e.target.id]: e.target.value,
                      },
                    })
                  }
                  value={createOrgForm.address.country}
                  sx={{ width: "100%" }}
                />
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl
                variant="standard"
                required
                sx={{ width: "300px", display: "block", marginTop: ".5rem" }}
              >
                <InputLabel htmlFor="pinCode">Pincode</InputLabel>
                <Input
                  id="pinCode"
                  onChange={(e) =>
                    setCreateOrgForm({
                      ...createOrgForm,
                      address: {
                        ...createOrgForm.address,
                        [e.target.id]: e.target.value,
                      },
                    })
                  }
                  value={createOrgForm.address.pinCode}
                  sx={{ width: "100%" }}
                />
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl
                variant="standard"
                sx={{
                  marginTop: ".5rem",
                }}
              >
                <FormControlLabel
                  value="top"
                  control={
                    <Checkbox
                      onChange={(e) => {
                        setLeiFlag(!leiFlag);
                      }}
                    />
                  }
                  label="LEI number not available as the company has not registered yet"
                />
              </FormControl>
              {leiFlag ? (
                ""
              ) : (
                <Box>
                  <FormControl
                    variant="standard"
                    required
                    sx={{
                      width: "300px",
                      display: "block",
                      marginTop: ".2rem",
                    }}
                  >
                    <InputLabel htmlFor="leiNumber">
                      LEI Number Customer
                    </InputLabel>
                    <Input
                      id="leiNumber"
                      onChange={(e) => {
                        setCreateOrgForm({
                          ...createOrgForm,
                          leiNumber: e.target.value,
                        });
                      }}
                      type="text"
                      sx={{ width: "100%" }}
                      value={createOrgForm.leiNumber}
                    />
                  </FormControl>
                </Box>
              )}
            </Grid>
            <Grid item xs={6}>
              <FormControl>
                <FormLabel
                  id="charteredAccountantChoice"
                  sx={{ fontSize: "18px" }}
                >
                  CA Preference ?
                </FormLabel>
                <RadioGroup
                  id="charteredAccountantChoice"
                  sx={{ display: "flex", width: "300px", flexDirection: "row" }}
                  onChange={(e) => {
                    setCreateOrgForm({
                      ...createOrgForm,
                      charteredAccountantChoice: e.target.value,
                    });
                  }}
                  value={createOrgForm.charteredAccountantChoice}
                >
                  <FormControlLabel
                    value={"OWN"}
                    control={<Radio />}
                    label="OWN"
                  />
                  <FormControlLabel
                    value={"KARBON"}
                    control={<Radio />}
                    label="KARBON"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
          </Grid>
          <Button type="submit" variant="contained" sx={{ marginTop: "2rem" }} disabled={loadingButton}>
            {editFlag ? "Update Organization" : "Create Organization"}
          </Button>
        </Box>
      </TabPanel> */}
      <TabPanel value={getState} index={0}>

        <Box component="form" validate onSubmit={(e) => createBankDetailFun(e)} disabled={mode === 'view' ? true : false}>
          <div className="bankDetailsCntr">
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <FormControl
                  variant="standard"
                  sx={{
                    width: "300px",
                    display: "block",
                    marginTop: ".5rem",
                  }}
                >
                  <InputLabel htmlFor="bankName">Bank Name</InputLabel>
                  <Input
                    id="bankName"
                    name="bankName"
                    sx={{ width: "100%" }}
                    onChange={(e) =>
                      setBankFormDetails({
                        ...getBankFormDetails,
                        [e.target.id]: e.target.value,
                      })
                    }
                    value={getBankFormDetails?.bankName}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <FormControl
                  variant="standard"
                  required
                  sx={{
                    width: "300px",
                    display: "block",
                    marginTop: ".5rem",
                  }}
                >
                  <InputLabel htmlFor="accountNumber">
                    Account Number
                  </InputLabel>
                  <Input
                    id="accountNumber"
                    name="accountNumber"
                    sx={{ width: "100%" }}
                    onChange={(e) =>
                      setBankFormDetails({
                        ...getBankFormDetails,
                        [e.target.id]: e.target.value,
                      })
                    }
                    value={getBankFormDetails?.accountNumber}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <FormControl
                  variant="standard"
                  sx={{
                    width: "300px",
                    display: "block",
                    marginTop: ".5rem",
                  }}
                >
                  <InputLabel htmlFor="ifscCode">IFSC Code</InputLabel>
                  <Input
                    id="ifscCode"
                    name="ifscCode"
                    sx={{ width: "100%" }}
                    onChange={(e) =>
                      setBankFormDetails({
                        ...getBankFormDetails,
                        [e.target.id]: e.target.value,
                      })
                    }
                    value={getBankFormDetails?.ifscCode}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <FormControl
                  variant="standard"
                  required
                  sx={{
                    width: "300px",
                    display: "block",
                    marginTop: ".5rem",
                  }}
                >
                  <InputLabel htmlFor="customerId">UCIC/CIF</InputLabel>
                  <Input
                    id="customerId"
                    name="customerId"
                    sx={{ width: "100%" }}
                    onChange={(e) =>
                      setBankFormDetails({
                        ...getBankFormDetails,
                        [e.target.id]: e.target.value,
                      })
                    }
                    value={getBankFormDetails?.customerId}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <FormControl>
                  <FormLabel id="isPrimaryAccount" sx={{ fontSize: "18px" }}>
                    Is Primary ?
                  </FormLabel>
                  <RadioGroup
                    id="isPrimaryAccount"
                    sx={{
                      display: "flex",
                      width: "300px",
                      flexDirection: "row",
                    }}
                    onChange={(e) => {
                      setBankFormDetails({
                        ...getBankFormDetails,
                        isPrimaryAccount: e.target.value
                      });
                    }}
                    value={getBankFormDetails?.isPrimaryAccount}
                  >
                    <FormControlLabel
                      value={true}
                      control={<Radio />}
                      label="YES"
                    />
                    <FormControlLabel
                      value={false}
                      control={<Radio />}
                      label="NO"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
            </Grid>
          </div>
          <Button type="submit" variant="contained" sx={{ marginTop: "2rem" }} disabled={loadingButton || mode === 'view' && true}>
            {mode === "edit" ? "Update Bank Details" : "Create Bank Details"}
          </Button>
        </Box>
      </TabPanel>
      <TabPanel value={getState} index={1}>
        <Box
          component="form"
          validate
          onSubmit={(e) => createAdBankDetailFun(e)}
          disabled={mode === 'view' ? true : false}
        >
          <div className="bankDetailsCntr">
            <Grid container spacing={2}>
              {/* {getSearchInput && (
                <Grid item xs={6}>
                  <SearchSelect
                    selectSearchData={selectSearchData}
                    label={"Select Organisation"}
                    name={"orgSelect"}
                  />
                </Grid>
              )} */}
              <Grid item xs={6}>
                <FormControl
                  variant="standard"
                  required
                  sx={{
                    width: "300px",
                    display: "block",
                    marginTop: ".5rem",
                  }}
                >
                  <InputLabel htmlFor="bankName">AD Bank Name</InputLabel>
                  <Input
                    id="bankName"
                    name="bankName"
                    sx={{ width: "100%" }}
                    onChange={(e) =>
                      setAdBankFormDetails({
                        ...getAdBankFormDetails,
                        [e.target.id]: e.target.value,
                      })
                    }
                    value={getAdBankFormDetails.bankName}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <FormControl
                  variant="standard"
                  required
                  sx={{
                    width: "300px",
                    display: "block",
                    marginTop: ".5rem",
                  }}
                >
                  <InputLabel htmlFor="ifscCode">AD Bank IFSC</InputLabel>
                  <Input
                    id="ifscCode"
                    name="ifscCode"
                    sx={{ width: "100%" }}
                    onChange={(e) =>
                      setAdBankFormDetails({
                        ...getAdBankFormDetails,
                        [e.target.id]: e.target.value,
                      })
                    }
                    value={getAdBankFormDetails?.ifscCode}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <FormControl
                  variant="standard"
                  required
                  sx={{
                    width: "300px",
                    display: "block",
                    marginTop: ".5rem",
                  }}
                >
                  <InputLabel htmlFor="bsrCode">AD Bank BSR Code</InputLabel>
                  <Input
                    id="bsrCode"
                    name="bsrCode"
                    sx={{ width: "100%" }}
                    onChange={(e) =>
                      setAdBankFormDetails({
                        ...getAdBankFormDetails,
                        [e.target.id]: e.target.value,
                      })
                    }
                    value={getAdBankFormDetails?.bsrCode}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <FormControl
                  variant="standard"
                  required
                  sx={{
                    width: "300px",
                    display: "block",
                    marginTop: ".5rem",
                  }}
                >
                  <InputLabel htmlFor="customerId">AD Bank UCIC/CIF</InputLabel>
                  <Input
                    id="customerId"
                    name="customerId"
                    sx={{ width: "100%" }}
                    onChange={(e) =>
                      setAdBankFormDetails({
                        ...getAdBankFormDetails,
                        [e.target.id]: e.target.value,
                      })
                    }
                    value={getAdBankFormDetails?.customerId}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <FormControl>
                  <FormLabel id="isPrimaryAccount" sx={{ fontSize: "18px" }}>
                    Is Primary ?
                  </FormLabel>
                  <RadioGroup
                    id="isPrimaryAccount"
                    sx={{
                      display: "flex",
                      width: "300px",
                      flexDirection: "row",
                    }}
                    onChange={(e) => {
                      setAdBankFormDetails({
                        ...getAdBankFormDetails,
                        isPrimaryAccount: e.target.value,
                      });
                    }}
                    value={getAdBankFormDetails?.isPrimaryAccount}
                  >
                    <FormControlLabel
                      value={true}
                      control={<Radio />}
                      label="YES"
                    />
                    <FormControlLabel
                      value={false}
                      control={<Radio />}
                      label="NO"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
            </Grid>
          </div>
          <Button type="submit" variant="contained" sx={{ marginTop: "2rem" }} disabled={loadingButton || mode === 'view' && true }>
            {mode === "edit" ? "Update AD Bank Details" : "Create AD Bank Details"}
          </Button>
        </Box>
      </TabPanel>
    </Box >
  );
}
